import { BREAKPOINT1 } from '@/wabunka-src/constants/breakpoints';

/**
 * 引数で値を受け取り、SP サイズかどうかを判定し、boolean を返却する
 * @returns {boolean} - SP サイズかどうか
 */
const getIsSP = (innerWidth: number): boolean => {
  return !!window && innerWidth < BREAKPOINT1;
};

/**
 * SP サイズかどうかの状態を保持する ref を返却する
 * @returns {Ref<boolean>}
 */
export const useIsSP = (): Ref<boolean> => {
  const isSP = ref<boolean>(false);

  const onResize = ({ target }: Event) => {
    isSP.value = (target as Window).innerWidth < BREAKPOINT1;
  };

  onMounted(() => {
    isSP.value = getIsSP(window.innerWidth);
    if (window) window.addEventListener('resize', onResize);
  });

  return isSP;
};
